export default "__VITE_ASSET__w79CBH6J__"